<template>
    <modal
        v-bind:visible="visible"
        class="is-form"
        v-on:closeModal="visible = false"

    >
        <template slot="header">Herkunft und Tags bearbeiten</template>

        <form slot="content" style="min-height: 100px">
            <loading v-if="isLoading">
            </loading>
            <table>
                <tr>
                    <th><label class="label">Herkunft der Anfrage</label></th>
                    <td>
                        <multiselect
                            class="is-shorter"
                            v-model="formRequestSource"
                            v-bind:options="options.requestSourceList || []"
                            label="value"
                            track-by="key"
                            placeholder="Herkunft der Anfrage"
                            :allow-empty="false"
                        />
                    </td>
                </tr>
                <tr>
                    <th><label class="label">Tags</label></th>
                    <td>
                        <multiselect
                            :options="options.orderTags ? options.orderTags : []"
                            v-model="traitTags"
                            v-bind:taggable="true"
                            multiple
                            v-on:tag="addTag"
                        >
                            <span slot="caret" ></span>
                        </multiselect>
                    </td>
                </tr>
                <tr v-if="isGrantedAdmin && useTagsForCommission" :class="{ 'is-proposed': proposedFields.includes('commissionSource') }">
                    <th><label class="label">Provisionsquelle</label></th>
                    <td>
                        <div class="level">
                            <div class="level-left" style="flex: 1">
                                <div class="level-item" style="flex: 1">
                                    <multiselect
                                        class="is-shorter"
                                        v-model="formCommissionSource"
                                        :options="commissionSourceOptions"
                                        label="value"
                                        track-by="key"
                                        placeholder="Provisionsquelle"
                                    />
                                </div>
                                <div class="level-item" style="flex: none" v-if="proposedFields.includes('commissionSource')">
                                    <popover trigger="hover">
                                        <i class="material-icons is-small has-text-link">info</i>
                                        <template slot="popover">Vorschlag basierend auf dem Tag – derzeit kein Wert gespeichert</template>
                                    </popover>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr v-if="isGrantedAdmin && useTagsForCommission" :class="{ 'is-proposed': proposedFields.includes('commission') }">
                    <th><label class="label">Provision (in %)</label></th>
                    <td>
                        <div class="level">
                            <div class="level-left" style="flex: 1">
                                <div class="level-item" style="flex: 1">
                                    <input-price
                                        v-model="commission"
                                        :digits="1"
                                        :nullable="true"
                                        prefix=""
                                    />
                                </div>
                                <div class="level-item" style="flex: none" v-if="proposedFields.includes('commission')">
                                    <popover trigger="hover">
                                        <i class="material-icons is-small has-text-link">info</i>
                                        <template slot="popover">Vorschlag basierend auf dem Tag – derzeit kein Wert gespeichert</template>
                                    </popover>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr v-if="isGrantedAdmin && useTagsForCommission" :class="{ 'is-proposed': proposedFields.includes('commissionCostDeduction') }">
                    <th><label class="label">Provisionsabzug (in %)</label></th>
                    <td>
                        <div class="level">
                            <div class="level-left" style="flex: 1">
                                <div class="level-item" style="flex: 1">
                                    <input-price
                                        v-model="commissionCostDeduction"
                                        :digits="1"
                                        :nullable="true"
                                        prefix=""
                                    />
                                </div>
                                <div class="level-item" style="flex: none" v-if="proposedFields.includes('commissionCostDeduction')">
                                    <popover trigger="hover">
                                        <i class="material-icons is-small has-text-link">info</i>
                                        <template slot="popover">Vorschlag basierend auf dem Tag – derzeit kein Wert gespeichert</template>
                                    </popover>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            </table>
        </form>

        <div slot="footer">
            <button class="button is-large" v-on:click="close"><i class="material-icons">close</i> Verwerfen</button>

            <button
                class="button is-primary is-large"
                v-bind:class="{ 'is-loading': isLoading }"
                v-on:click="saveForm"
            ><i class="material-icons">check</i> Speichern</button>
        </div>


    </modal>
</template>



<script>

import Modal                               from '@components/Modal';
import {edit, editOrder, getAxios, getOrder, post} from "@api";
import Loading from "@components/Loading";
import {Multiselect, InputPrice} from "@components/form";
import {notifyError, notifySuccess} from "@components/Notification";
import Popover from '@components/Popover';
import axios from "axios";
import store from "@orders/store";
import { currentUser } from "@utilities/functions";
import { tagCommissionPresets } from "@clientSpecific/utilities/defaultValues";
import { settings } from "@clientSpecific/utilities/settings";



export default {
    store,

    data () {
        return {
            isLoading: false,
            visible: false,
            loggedInUser: currentUser(),
            commissionSourceOptions: [
                { key: 'revenue',  value: 'Umsatz' },
                { key: 'earnings', value: 'Gewinn' },
            ],
            dbOrder: null,
        }
    },

    computed: {
        traitTags: {
            get: function () { return this.$store.state.order && this.$store.state.order.traitTags; },
            set: function (traitTags) {
                this.$store.commit('updateOrder', { traitTags } )
            }
        },
        formRequestSource: {
            get: function () {
                return this.options.requestSourceList && this.$store.state.order &&
                    this.options.requestSourceList.find(category => this.$store.state.order.requestSource === category.key)
            },
            set: function (category) {
                this.$store.commit('updateOrder', { requestSource: category ? category.key : null } )
            }
        },
        commission: {
            get: function () { return this.$store.state.order && this.$store.state.order.commission; },
            set: function (commission) {
                this.$store.commit('updateOrder', { commission } )
            }
        },
        commissionCostDeduction: {
            get: function () { return this.$store.state.order && this.$store.state.order.commissionCostDeduction; },
            set: function (commissionCostDeduction) {
                this.$store.commit('updateOrder', { commissionCostDeduction } )
            }
        },
        formCommissionSource: {
            get: function () {
                const key = this.$store.state.order && this.$store.state.order.commissionSource;
                return this.commissionSourceOptions.find(o => o.key === key)
                    || this.commissionSourceOptions.find(o => o.key === 'revenue');
            },
            set: function (option) {
                this.$store.commit('updateOrder', { commissionSource: option ? option.key : null });
            }
        },
        proposedFields: function () {
            if (!this.dbOrder) return [];
            const tags = this.dbOrder.traitTags || [];
            const preset = tagCommissionPresets.find(p => tags.includes(p.tag));
            if (!preset) return [];
            const proposed = [];
            if (this.dbOrder.commissionSource == null)        proposed.push('commissionSource');
            if (this.dbOrder.commission == null)              proposed.push('commission');
            if (this.dbOrder.commissionCostDeduction == null) proposed.push('commissionCostDeduction');
            return proposed;
        },
        options () { return this.$store.state.options},
        orderID:    function () { return this.$store.state.orderID; },
        isGrantedAdmin: function () {
            return this.loggedInUser && this.loggedInUser.roles && this.loggedInUser.roles.includes('ROLE_ADMIN');
        },
        useTagsForCommission: function () {
            return settings.order.useTagsForCommission === true;
        },

    },


    methods: {


        addTag (tag) {
            let tags = this.traitTags || [];
            tags.push(tag);
            this.traitTags   = tags;
        },

        updateTags: function () {
            this.isLoading = true;
            editOrder({
                id: this.orderID,
                data: { traitTags: this.traitTags, requestSource: this.formRequestSource ? this.formRequestSource.key : null, commission: this.commission !== null && this.commission !== undefined ? parseFloat(this.commission) : null, commissionCostDeduction: this.commissionCostDeduction !== null && this.commissionCostDeduction !== undefined ? parseFloat(this.commissionCostDeduction) : null, commissionSource: this.formCommissionSource ? this.formCommissionSource.key : null }
            }).then(response => {
                notifySuccess('Tags und Herkunft wurden aktualisiert!');
                this.isLoading = false;
                this.$emit('saved');
                this.close()

            }, error => {
                notifyError('Tags oder Herkunft konnten nicht aktualisiert werden!');
                this.isLoading = false;

            });
        },

        saveForm: function() {
            this.updateTags();
        },

        close: function() {
            this.visible = false;
            this.dbOrder = null;
        },

        openModal: function (){
            this.visible = true;
            this.isLoading = true;
            Promise.all([
                getOrder(this.orderID, '?_groups[]=order_read'),
                axios.options('/api/user-dashboard'),
            ]).then(([orderResponse, optionsResponse]) => {
                const order = orderResponse.data;
                this.$store.commit('updateOrder', {
                    requestSource: order.requestSource,
                    commission: order.commission,
                    commissionCostDeduction: order.commissionCostDeduction,
                    commissionSource: order.commissionSource,
                    traitTags: order.traitTags,
                });
                this.$store.commit('updateOptions', optionsResponse.data);
                this.dbOrder = order;
                this.applyTagPreset(order.traitTags, order);
                this.isLoading = false;
            }, () => {
                this.isLoading = false;
            });
        },

        openWithRow: function (row) {
            this.$store.commit('updateOrder', { id: row.id, traitTags: row.traitTags });
            this.visible = true;
            this.isLoading = true;
            Promise.all([
                getOrder(row.id, '?_groups[]=order_read'),
                axios.options('/api/user-dashboard'),
            ]).then(([orderResponse, optionsResponse]) => {
                const order = orderResponse.data;
                this.$store.commit('updateOrder', {
                    requestSource: order.requestSource,
                    commission: order.commission,
                    commissionCostDeduction: order.commissionCostDeduction,
                    commissionSource: order.commissionSource,
                    traitTags: order.traitTags,
                });
                this.$store.commit('updateOptions', optionsResponse.data);
                this.dbOrder = order;
                this.applyTagPreset(order.traitTags, order);
                this.isLoading = false;
            }, () => {
                this.isLoading = false;
            });
        },

        applyTagPreset: function (tags, order) {
            if (!tags) return;
            const preset = tagCommissionPresets.find(p => tags.includes(p.tag));
            if (!preset) return;
            const patch = {};
            if (order.commissionSource == null)        patch.commissionSource = preset.commissionSource;
            if (order.commission == null)              patch.commission = preset.commission;
            if (order.commissionCostDeduction == null) patch.commissionCostDeduction = preset.commissionCostDeduction;
            if (Object.keys(patch).length > 0) {
                this.$store.commit('updateOrder', patch);
            }
        },
    },





    watch: {
        traitTags: function (tags) {
            if (this.isLoading || this._applyingPreset) return;
            this._applyingPreset = true;
            if (this.dbOrder) {
                const reset = {};
                if (this.dbOrder.commissionSource == null)        reset.commissionSource = null;
                if (this.dbOrder.commission == null)              reset.commission = null;
                if (this.dbOrder.commissionCostDeduction == null) reset.commissionCostDeduction = null;
                if (Object.keys(reset).length > 0) {
                    this.$store.commit('updateOrder', reset);
                }
            }
            this.applyTagPreset(tags, this.dbOrder || {});
            this.$nextTick(() => { this._applyingPreset = false; });
        },
    },

    components: {
        Multiselect,
        Loading,
        Modal,
        InputPrice,
        Popover,
    }
}
</script>

